import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Report from "../Report";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import SubGroup from "../SubGroup";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelectGame from "../InputSelectGame";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() + 1);

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = currentDate.toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function ChangesByGame() {
  const [endDate, setEndDate] = useState(endDateValue);

  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback((event) => {
    setStartDate(event.target.value);

    const endDateChanged = new Date(event.target.value);
    endDateChanged.setDate(endDateChanged.getDate() + 1);
    setEndDate(endDateChanged.toISOString().split("T")[0]);
  }, []);

  const [option, setOption] = useState(0);
  const onOptionChange = useCallback(
    (event) => setOption(Number(event.target.value)),
    []
  );

  const [idGame, setIdGame] = useState(0);
  const onGameChanged = useCallback((g) => setIdGame(g), []);

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Game Date"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelectGame
          startDate={startDate}
          endDate={endDate}
          setSelectValue={onGameChanged}
        />
        <div>
          <SubGroup title="Changes On">
            <FormControl component="fieldset">
              <RadioGroup label value={option} onChange={onOptionChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Status"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Time"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Score"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Changes By Game Report"
        getUrl={() => "/Reports/Report_Game_Status_Changes_By_Game_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          Option: option,
          IdGame: idGame,
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="modification"
          dataFormat={dateTimeReportFormatter}
        >
          Change Time
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="loginName">
          User
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="visitor">
          Visitor
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="home">
          Home
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="oldStatus">
          Change From
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="newStatus">
          To
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default ChangesByGame;
